import axios from 'axios';

const createClient = (baseURL) => axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true,
});

let adminUnauthorizedHandler = null;

export const setAdminUnauthorizedHandler = (handler) => {
  adminUnauthorizedHandler = typeof handler === 'function' ? handler : null;
};

export const publicApi = createClient('/api/public');
export const adminApi = createClient('/api/admin');

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const isUnauthorized = error.response && error.response.status === 401;
    const isLoginRequest = error.config?.url === '/auth/login';
    const shouldSkipUnauthorizedHandler = error.config?.skipAdminUnauthorizedHandler;

    if (isUnauthorized && !isLoginRequest && !shouldSkipUnauthorizedHandler) {
      window.localStorage.removeItem('admin_session_expires_at');
      adminUnauthorizedHandler?.(error);
    }

    return Promise.reject(error);
  },
);
